<template lang="pug">
.card.mb-0
  template(v-if="mode != 0")
    .card-header
      .section-header-back
        a.btn.btn-sm.btn-icon.pl-0(href="javascript:void(0)" @click="redirect(mode = mode-1)")
          i.fas.fa-arrow-left
      h4(v-if="mode == 1") {{ $t("ui.reward_rain_session") }}
      h4(v-else-if="mode == 2") {{ $t("ui.reward_rain_session_claim") }}
      .section-header-breadcrumb.ml-auto.d-flex
        .breadcrumb-item
          a(href="javascript:void(0);" @click="redirect(0)") {{ $t("ui.reward_rain") }}
        .breadcrumb-item.active(v-if="mode == 1")
          span {{ $t("ui.reward_rain_session") }}
        template(v-else-if="mode == 2")
          .breadcrumb-item
            a(href="javascript:void(0);" @click="redirect(1)") {{ $t("ui.reward_rain_session") }}
          .breadcrumb-item.active
            span {{ $t("ui.reward_rain_session_claim") }}
  template(v-if="mode == 0")
    .card-header
      .row.w-100
        .form-group.col-md-3.col-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.status') }}
            b-form-select(v-model="campaignStatus" @change="getRewardRainCampaignList(true)" :disabled="loading" size="sm")
              option(:value="null") {{ $t('ui.all') }}
              option(value=1) {{ $t('ui.active') }}
              option(value=-1) {{ $t('ui.inactive') }}
        .form-group.col-md-9.col-10.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getRewardRainCampaignList(true)"
            variant="primary"
            size="sm"
          )
        .form-group.col-6.mb-1(v-if="isEditAccess")
          b-button(v-b-modal.addRewardRainCampaign type="button" variant="info" size="sm")
            i.fa.fa-plus
            span.ml-1 {{ $t("ui.combine.add_reward_rain") }}
    .card-body
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)"
          )
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-12
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="10%" @click="sortOrder('rrc_name')")
                    span(:title="$t('ui.name')") {{ $t("ui.name") }}
                    .float-right
                      i(:class="changeSortKey('rrc_name')")
                  th(width="10%")
                    span(:title="$t('ui.description')") {{ $t("ui.description") }}
                  th.text-center(width="10%" @click="sortOrder('status')")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                    .float-right
                      i(:class="changeSortKey('status')")
                  th.text-right(width="10%")
                    span(:title="$t('ui.total_claimed_amount')") {{ $t("ui.total_claimed_amount") }}
                  th.text-center(width="10%" v-if="isEditAccess")
                    span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  th.text-right(width="10%" @click="sortOrder('created_at')")
                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                    .float-right
                      i(:class="changeSortKey('created_at')")
                  th.text-right(width="10%")
                    span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
              tbody.clusterize-content
                tr(v-if="rewardRainCampaignList.length == 0")
                  td(colspan="9").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in rewardRainCampaignList")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.rrc_name")
                      b-link.text-decoration-none(href="javascript:void(0);" @click="pageMode(item.id ,item.rrc_name, 1)") {{ item.rrc_name }}
                  td
                    span(:title="item.rrc_desc") {{ item.rrc_desc }}
                  td
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.total_claimed_amount)" :title="$n(item.total_claimed_amount, 'currency')") {{ $n(item.total_claimed_amount, 'currency') }}
                  td.text-center(v-if="isEditAccess")
                    span.mr-2
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                        href="javascript:void(0)"
                        @click="onEdit(item)"
                        :title="$t('ui.edit')"
                        )
                  td.text-right
                    span.d-block(:title="item.created_by") {{ item.created_by }}
                    span(v-if="item.created_at" :title="$moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss') }}
                  td.text-right
                    span.d-block(:title="item.modified_by") {{ item.modified_by }}
                    span(v-if="item.modified_at" :title="$moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss') }}

      addrewardraincampaign(@clicked="addRewardRainCampaign" @failed="handleFailed")
      editrewardraincampaign(ref="editrewardraincampaign" :item="editSelectedRrc" @clicked="afterEdit" @failed="handleFailed")

  template(v-else-if="mode == 1")
    rewardRainSession(ref="rewardRainSession" :operatorID="operatorID" :rrcId="rrcId" :rrcName="rrcName" @clicked="pageMode")
  template(v-else-if="mode == 2")
    rewardRainSessionClaim(ref="rewardRainSessionClaim" :operatorID="operatorID" :rrsId="rrsId" :rrsName="rrsName")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addrewardraincampaign from "@/components/rewardTab/addRewardRainCampaign.vue";
import editrewardraincampaign from "@/components/rewardTab/editRewardRainCampaign.vue";
import rewardRainSession from "@/components/rewardTab/rewardRainSession.vue";
import rewardRainSessionClaim from "@/components/rewardTab/rewardRainSessionClaim.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addrewardraincampaign,
    editrewardraincampaign,
    rewardRainSession,
    rewardRainSessionClaim
  },
  data: () => ({
    loading: false,
    rewardRainCampaignList: [],
    sortKey: "",
    sortType: "",
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    campaignStatus: null,
    editSelectedRrc: null,
    rrcId: null,
    rrcName: null,
    rrsId: null,
    rrsName: null,
    mode: 0 // 0 = rewardrain , 1 = rewardrainsession, 2 = rewardrainsessionclaim
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeRewardRain;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_rewardrain");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.mode = 0
      this.getRewardRainCampaignList(true)
    },
    redirect(mode) {
      this.mode = mode
      this.rrsId = null
      this.rrsName = null

      switch(this.mode) {
        case 0:
          this.rrcId = null
          this.rrcName = null
          this.campaignStatus = null
          this.$nextTick(() => {
            this.getRewardRainCampaignList(true);
          });
          break
        case 1:
          this.$nextTick(() => {
            this.$refs.rewardRainSession.refresh()
          });
          break
      }
    },
    pageMode(id, name, e) {
      this.mode = e
      let ref = null;

      switch(this.mode) {
        case 1:
          this.rrcId = id
          this.rrcName = name
          ref = "rewardRainSession";
          break

        case 2:
          this.rrsId = id
          this.rrsName = name
          ref = "rewardRainSessionClaim";
          break
      }

      if (ref) {
        this.$nextTick(() => {
          this.$refs[ref].refresh();
        });
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getRewardRainCampaignList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    addRewardRainCampaign: function() {
      this.campaignStatus = null;
      this.getRewardRainCampaignList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_reward_rain"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedRrc = e;
      this.$refs.editrewardraincampaign.$refs.editRewardRainCampaign.show();
    },
    afterEdit() {
      this.getRewardRainCampaignList(true);
      this.$helpers.showDialog(this.$t("ui.combine.edit_reward_rain"), this.$t("message.success"), "success");
    },
    getRewardRainCampaignList: function(isSearch) {
      let url = config.rewardRainCampaignlistUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        campaign_status: null,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      if (this.campaignStatus == 1) {
        json.campaign_status = true;
      } else if (this.campaignStatus == -1) {
        json.campaign_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rewardRainCampaignList = response.data.dt;
                this.totalRow = this.rewardRainCampaignList.length > 0 ? this.rewardRainCampaignList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_reward_rain_status_confirm", { name: item.rrc_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.rewardCampaignStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        campaign_id: item.id,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getRewardRainCampaignList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getRewardRainCampaignList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeRewardRain", pageSize);
      this.currentPage = 1;
      this.getRewardRainCampaignList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRewardRainCampaignList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>